// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2nMcY","productName":"Table_productName__t_mSR"};